/* —— 1. COUNTDOWN TIMER —— */
(function(){
  var end = new Date();
  end.setHours(end.getHours()+5, end.getMinutes()+47, end.getSeconds()+33);
  function tick(){
    var diff = end - new Date();
    if (diff < 0){ end = new Date(new Date().getTime()+6*3600000); diff = end - new Date(); }
    var h = Math.floor(diff/3600000);
    var m = Math.floor((diff%3600000)/60000);
    var s = Math.floor((diff%60000)/1000);
    var elH=document.getElementById('cdHours'), elM=document.getElementById('cdMins'), elS=document.getElementById('cdSecs');
    if(elH) elH.textContent=String(h).padStart(2,'0');
    if(elM) elM.textContent=String(m).padStart(2,'0');
    if(elS) elS.textContent=String(s).padStart(2,'0');
  }
  tick(); setInterval(tick,1000);
})();

/* —— 2. BUNDLE SELECTOR (+ color/variant dropdown) —— */
function selectBundle(card){
  document.querySelectorAll('.op-bnd__card').forEach(function(c){c.classList.remove('op-sel');});
  card.classList.add('op-sel');
  var sale=card.dataset.sale, orig=card.dataset.orig, pct=card.dataset.pct, lbl=card.dataset.lbl;
  var qty=card.dataset.qty || '1', vid=card.dataset.variantId || '';
  // Update display values
  var elSale=document.getElementById('opSalePrice'),
      elOrig=document.getElementById('opOrigPrice'),
      elPill=document.getElementById('opSavePill'),
      elLbl =document.getElementById('opBundleLbl'),
      elSATC=document.getElementById('opSatcPrice');
  if(elSale) elSale.textContent=sale;
  if(elOrig) elOrig.textContent=orig;
  if(elPill) elPill.textContent=pct;
  if(elLbl)  elLbl.textContent =lbl;
  if(elSATC) elSATC.textContent=sale;
  // Update real cart-form values so the ATC button posts the right product
  var elQty = document.getElementById('opCartQty');
  var elVid = document.getElementById('opVariantId');
  if(elQty) elQty.value = qty;
  if(elVid && vid) elVid.value = vid;

  // Swap the color/variant dropdown options based on this card's data-options
  var sel = document.getElementById('opBundleVar');
  var row = document.getElementById('opBundleVarRow');
  var lblEl = document.getElementById('opBundleVarLbl');
  if(!sel || !row) return;
  var raw = card.dataset.options || '[]';
  var opts = [];
  try { opts = JSON.parse(raw); } catch(e){ opts = []; }
  // Hide the dropdown entirely if this card has no options
  if(!opts.length){ row.style.display='none'; return; }
  row.style.display = '';
  if(lblEl) lblEl.textContent = card.dataset.colorLabel || 'Color';
  sel.innerHTML = '';
  var defaultIdx = 0;
  opts.forEach(function(o, i){
    var op = document.createElement('option');
    op.value = o.variant_id || '';
    op.textContent = o.label || '';
    sel.appendChild(op);
    if(o.is_default) defaultIdx = i;
  });
  sel.selectedIndex = defaultIdx;
  // Push the default-selected option's variant ID into the ATC form
  if(elVid && opts[defaultIdx] && opts[defaultIdx].variant_id){
    elVid.value = opts[defaultIdx].variant_id;
  }
}

/* —— 2a. COLOR / VARIANT DROPDOWN CHANGE —— */
function onBundleVarChange(sel){
  if(!sel) return;
  var elVid = document.getElementById('opVariantId');
  if(elVid && sel.value){ elVid.value = sel.value; }
}

/* —— 2b. INIT: populate dropdown from the default-selected bundle on page load —— */
document.addEventListener('DOMContentLoaded', function(){
  var defCard = document.querySelector('.op-bnd__card.op-sel');
  if(defCard){ selectBundle(defCard); }
});

/* —— 2b. STICKY ATC TRIGGER — Submits the main hero ATC form —— */
function submitOpCart(){
  var f = document.getElementById('opAtcForm');
  if(f){ f.submit(); }
}

/* —— 3. GALLERY CAROUSEL – native scroll-snap, thumb sync —— */

/* Dots are an optional second indicator alongside the thumb row (show_gallery_dots).
   Kept in its own helper so both the click path and the scroll path mark the same index —
   a dot row that disagrees with the photo on screen is worse than no dot row. */
function opGalSyncDots(sectionId, idx){
  var dots = document.querySelectorAll('#opGalDots-' + sectionId + ' .op-gal__dot');
  dots.forEach(function(d, i){
    if(i === idx) d.classList.add('op-act'); else d.classList.remove('op-act');
  });
}

function opGalGoTo(sectionId, idx, thumbEl){
  var main = document.getElementById('opGalMain-' + sectionId);
  if(!main) return;
  var slides = main.querySelectorAll('.op-gal__slide');
  if(!slides[idx]) return;
  main.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
  var thumbs = document.querySelectorAll('#opGalThumbs-' + sectionId + ' .op-gal__thumb');
  thumbs.forEach(function(t){ t.classList.remove('op-act'); });
  if(thumbEl){ thumbEl.classList.add('op-act'); }
  else if(thumbs[idx]){ thumbs[idx].classList.add('op-act'); }
  opGalSyncDots(sectionId, idx);
}

/* Step the gallery one image left/right (used by the prev/next arrows).
   The current index comes from the SCROLLER, not from which thumbnail carries .op-act.
   That matters: with hide_gallery_thumbs the thumb row does not exist, and the old
   thumb-based lookup bailed out on an empty NodeList — which left the on-photo arrows
   dead on exactly the layout that has nothing else to navigate with. The scroll position
   is the real state anyway, so both layouts now read from the same place. */
function opGalStep(sectionId, dir){
  var main = document.getElementById('opGalMain-' + sectionId);
  if(!main) return;
  var slides = main.querySelectorAll('.op-gal__slide');
  if(!slides.length) return;
  var w = main.clientWidth || 1;
  var cur = Math.round(main.scrollLeft / w);
  var next = cur + dir;
  if(next < 0) next = slides.length - 1;
  if(next >= slides.length) next = 0;
  opGalGoTo(sectionId, next);
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[id^="opGalMain-"]').forEach(function(main){
    var sectionId = main.id.replace('opGalMain-', '');
    var thumbs = document.querySelectorAll('#opGalThumbs-' + sectionId + ' .op-gal__thumb');
    var dots   = document.querySelectorAll('#opGalDots-' + sectionId + ' .op-gal__dot');
    if(!thumbs.length && !dots.length) return;
    var st = null;
    main.addEventListener('scroll', function(){
      if(st) clearTimeout(st);
      st = setTimeout(function(){
        var w = main.clientWidth;
        if(!w) return;
        var idx = Math.round(main.scrollLeft / w);
        thumbs.forEach(function(t, i){ if(i === idx) t.classList.add('op-act'); else t.classList.remove('op-act'); });
        opGalSyncDots(sectionId, idx);
      }, 80);
    }, { passive: true });
  });
});

/* —— 4. BUYBOX ACCORDION —— */
function toggleBuyboxAccordion(btn){
  var item = btn.closest('.op-acc__item');
  var body = item.querySelector('.op-acc__body');
  var isOpen = item.classList.contains('op-open');
  document.querySelectorAll('.op-acc__item').forEach(function(i){
    i.classList.remove('op-open');
    var b = i.querySelector('.op-acc__body'); if(b) b.style.maxHeight='0';
  });
  if(!isOpen){ item.classList.add('op-open'); body.style.maxHeight = body.scrollHeight+'px'; }
}

/* —— 5. FAQ ACCORDION —— */
function toggleFaqAccordion(btn){
  var item = btn.closest('.op-faq__item');
  var body = item.querySelector('.op-faq__body');
  var isOpen = item.classList.contains('op-open');
  document.querySelectorAll('.op-faq__item').forEach(function(i){
    i.classList.remove('op-open');
    var b = i.querySelector('.op-faq__body'); if(b) b.style.maxHeight='0';
  });
  if(!isOpen){ item.classList.add('op-open'); body.style.maxHeight = body.scrollHeight+'px'; }
}

/* —— 6. STATS COUNT-UP —— */
(function(){
  var hasRun = false;
  function animateStats(){
    if(hasRun) return; hasRun = true;
    document.querySelectorAll('.op-cu').forEach(function(el){
      var target = parseInt(el.dataset.t,10);
      var current = 0;
      var stepTime = Math.max(10, Math.round(1600/target));
      var timer = setInterval(function(){
        current++;
        el.textContent = current+'%';
        if(current >= target) clearInterval(timer);
      }, stepTime);
    });
  }
  if('IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting) animateStats();
    }, { threshold: 0.3 });
    var statsSection = document.querySelector('.op-stats-section');
    if(statsSection) observer.observe(statsSection);
  } else { animateStats(); }
})();

/* —— 7. GIFT COUNT DECREMENT —— */
(function(){
  var count = 47;
  var el = document.getElementById('opGiftCount');
  if(!el) return;
  setInterval(function(){
    if(Math.random() < 0.12 && count > 5){ count--; el.textContent = count; }
  }, 14000);
})();

/* —— 8. STICKY MOBILE ATC + DELIVERY BANNER —— */
(function(){
  var heroSection = document.getElementById('opHeroSection');
  var stickyBar   = document.getElementById('opStickyAtc');
  var delivBar    = document.getElementById('opDelivBar');
  if(!heroSection || !stickyBar) return;
  window.addEventListener('scroll', function(){
    var heroBottom = heroSection.getBoundingClientRect().bottom;
    if(heroBottom < 0){
      stickyBar.classList.add('op-show');
      if(delivBar) delivBar.classList.add('op-show');
    } else {
      stickyBar.classList.remove('op-show');
      if(delivBar) delivBar.classList.remove('op-show');
    }
  }, { passive: true });
})();

/* —— 9. DELIVERY DATE + COUNTDOWN TO MIDNIGHT —— */
(function(){
  var dateEl    = document.getElementById('opDeliveryDate');
  var cdEl      = document.getElementById('opDeliveryCountdown');
  var bannerEl  = document.getElementById('opDelivBarDate');
  if(!dateEl && !cdEl && !bannerEl) return;
  // Delivery date = today + 4 calendar days (skipping Sun)
  function getDeliveryDate(longForm){
    var d = new Date(); d.setDate(d.getDate()+4);
    if(d.getDay()===0) d.setDate(d.getDate()+1); // skip Sunday
    var days=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return longForm ? days[d.getDay()]+', '+d.getDate()+' '+months[d.getMonth()] : days[d.getDay()];
  }
  if(dateEl)   dateEl.textContent   = getDeliveryDate(true);
  if(bannerEl) bannerEl.textContent = getDeliveryDate(true);
  function tickDelivery(){
    var end = new Date(); end.setHours(23,59,59,0);
    var diff = end - new Date();
    if(diff < 0){
      if(dateEl)   dateEl.textContent   = getDeliveryDate(true);
      if(bannerEl) bannerEl.textContent = getDeliveryDate(true);
      diff += 86400000;
    }
    var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
    if(cdEl) cdEl.textContent = String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
  }
  tickDelivery(); setInterval(tickDelivery, 1000);
})();
